import { render } from "./SearchInvoiceNumber.vue?vue&type=template&id=3b63d96f"
import script from "./SearchInvoiceNumber.vue?vue&type=script&lang=js"
export * from "./SearchInvoiceNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__